var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoMin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 474,
    viewBox: "0 0 474 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 237,
    r: 237,
    fill: "url(#paint0_radial_1_3)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.141 390.902C164.141 393.077 165.233 395.071 166.968 396.088C168.702 397.104 170.81 396.973 172.431 395.745L208.935 368.16L164.142 344.532V390.902H164.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.296 79.7914C380.293 78.7684 378.999 78.2331 377.691 78.2331C376.903 78.2331 376.116 78.4267 375.372 78.8315L60.2381 249.908C57.0171 251.66 54.9789 255.3 55.0007 259.282C55.0226 263.259 57.0953 266.875 60.3395 268.588L143.394 312.385L309.46 161.327L163.972 323.235L267.437 377.795C268.708 378.469 270.095 378.804 271.468 378.804C272.64 378.804 273.8 378.568 274.905 378.088C277.314 377.033 279.229 374.921 280.186 372.253L382.624 86.2549C383.435 84.0044 382.907 81.4311 381.296 79.7914Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_3",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(330 88) rotate(122.786) scale(404.427 324.384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023548"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 474,
    height: 474,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 363,
    fill: "white",
    transform: "translate(55 56)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoMin);
export default __webpack_public_path__ + "static/media/mainLogoMin.b0fda921f0f952a1266d77960b519a61.svg";
export { ForwardRef as ReactComponent };